import { getDevOrg, computeHost } from '../lib/dev-org.js';

/**
 * @module beebee-base/instance-initializers/dev-host
 * @description In sviluppo, sovrascrive l'host API in base all'organizzazione
 * salvata in localStorage (`beebee_dev_org`), così da poter cambiare tenant
 * (es. fisiotest, maestriscicristallo) senza editare `config/environment.js`.
 *
 * Gira PRIMA dell'init delle route/adapter: l'adapter legge l'host da config
 * tramite getter e le route catturano urlApi/urlFileUpload una sola volta al
 * boot, quindi mutare config qui fa sì che tutti vedano l'host corretto.
 *
 * NON ha alcun effetto in produzione (guard sull'environment) né quando
 * localStorage è vuoto (fallback al default di environment.js).
 */

function initialize(appInstance) {
  const config = appInstance.resolveRegistration('config:environment');
  if (!config || config.environment !== 'development') {
    return;
  }
  const org = getDevOrg();
  if (!org) {
    return;
  }
  const host = computeHost(org);
  config.APP.host = host;
  config.APP.urlApi = `${host}/v1`;
  config.APP.urlFileUpload = `${host}/v1/app/file`;
}
var devHost = {
  initialize
};

export { devHost as default, initialize };
//# sourceMappingURL=dev-host.js.map
